import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { winnreAuth } from '../../utils/axios';

const useData = () => {
    const [pointActivitiesList, setPointActivitiesList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadMore, setLoadMore] = useState(8);
    const [totalPages, setTotalPages] = useState(1);
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

    const getPointActivitiesList = () => {
        setLoading(true);
        winnreAuth({
            method: 'GET',
            // url: `/winnre/user/reward-audit`
            url: `/winnre/user/reward-audit?rewardType=RELOY_REWARDS&isAscending=false&pageSize=${loadMore}`
        })
            .then((res) => {
                console.log('all point activity', res);
                if (
                    res?.status === 'INVALID_TOKEN' ||
                    res?.status === 'FAILED'
                ) {
                     setTotalPages(0);
                    toast.error('Something Went Wrong');
                    return;
                }
                setLoading(false);
                setPointActivitiesList(res?.content);
                setTotalPages(res.totalPages || 1);
            })
            .catch((err) => {
                toast.error('Something went wrong. Please try again');
            });
    };

    useEffect(() => {
        if (isAuthenticated) {
            getPointActivitiesList();
        }
    }, [isAuthenticated]);

    return {
        loading,
        pointActivitiesList,
        setLoadMore,
        totalPages
    };
};
export default useData;
